import React from 'react';
import * as Sentry from '@sentry/browser';
import { Button } from 'shared/components/Button';
import { BellMessage } from 'shared/components/BellMessage';
import Loader from 'shared/components/Loader';
import log from 'shared/utils/log';
import './index.less';

interface Props {
  error: Error;
}

const isChunkError = (err: Error) => {
  return err.message.includes('Loading chunk');
};

export default class ErrorScreen extends React.PureComponent<Props> {
  componentDidMount() {
    const { error } = this.props;
    if (isChunkError(error)) {
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } else {
      Sentry.captureException(error);
      log.error(
        `Error screen showing due to the following error: ${error}`,
        undefined,
        error,
      );
    }
  }

  render() {
    const { error } = this.props;
    if (isChunkError(error)) {
      return <Loader size="large" />;
    }

    return (
      <div className="ErrorScreen">
        <BellMessage
          type="error"
          title="Whoa nelly."
          text={
            <div className="ErrorScreen-desc">
              <p>Something went wrong, and we've logged the following error:</p>
              <code className="ErrorScreen-desc-error">{error.message}</code>
              <p>Our developers will get right on fixing it.</p>
            </div>
          }
          action={
            <div className="ErrorScreen-buttons">
              <a href="/">
                <Button size="large" type="primary">
                  Return home
                </Button>
              </a>
            </div>
          }
        />
      </div>
    );
  }
}
